import { ReactComponent as Dot } from '../assets/icons/dot.svg'
import { ReactComponent as Search } from '../assets/icons/search.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import { ReactComponent as DataNull } from '../assets/icons/data-null.svg'
import { ReactComponent as SelectNull } from '../assets/icons/select-null.svg'
import { ReactComponent as CheckBox } from '../assets/icons/check-box.svg'
import { ReactComponent as CheckedBox } from '../assets/icons/checked-box.svg'
// import { ReactComponent as Check } from '../assets/icons/checkmark.svg'
import { useEffect, useState } from 'react'
import { fileTypeList } from '../assets/data'
import { getDocuments, PostDocumentsDownloadImage } from '../apis/document.ts'
import Slide from './Slide.jsx'
import { PostClassRoomBoardDocument } from '../apis/classRoom.ts'

export default function LoadDocument({
  close,
  subjectId,
  currentPage,
  classroomId,
  getApi,
  setCurrentPage,
}) {
  const [sortedBy, setSortedBy] = useState(1)
  const sortedByList = [
    { id: 1, name: '자료 이름순', type: 'name' },
    // { id: 2, name: '최근 수업 이용 순', type: 'recentUse' },
    { id: 3, name: '최근 등록 순', type: 'recentPost' },
  ]

  /*************** 자료목록 조회 API **************/
  const [documentList, setDocumentList] = useState([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    getDocumentsApi()
    // eslint-disable-next-line
  }, [sortedBy, search])

  const getCategoryType = (id) => {
    const item = sortedByList.find((item) => item.id === id)
    return item.type
  }

  const getDocumentsApi = async () => {
    const getDocumentsResponse = await getDocuments({
      subjectId: subjectId,
      name: search,
      sortBy: getCategoryType(sortedBy),
    })

    if (getDocumentsResponse.error) {
      console.log(getDocumentsResponse.error)
      return
    } else {
      // console.log(getDocumentsResponse.data)
      setDocumentList(getDocumentsResponse.data)
    }
  }

  /*************** 보드 생성 - 자료 API **************/
  const postClassRoomBoardDocumentApi = async (selectedImageIds) => {
    const postClassRoomBoardDocumentResponse = await PostClassRoomBoardDocument(
      {
        classroomId: classroomId,
      },
      {
        currentPageNumber: currentPage,
        documentImageIds: selectedImageIds,
      },
    )

    if (postClassRoomBoardDocumentResponse.error) {
      console.log(postClassRoomBoardDocumentResponse.error)
      return
    } else {
      console.log(postClassRoomBoardDocumentResponse.result)
      setCurrentPage(postClassRoomBoardDocumentResponse.data)
      // setImageList(postClassRoomBoardDocumentResponse.data)
    }
  }

  /*************** 특정 자료 하위 이미지 가져오기 API **************/
  const [imageList, setImageList] = useState([])
  const postDocumentsDownloadImageApi = async (documentId) => {
    const postDocumentsDownloadImageResponse = await PostDocumentsDownloadImage({
      documentId: documentId,
    })

    if (postDocumentsDownloadImageResponse.error) {
      console.log(postDocumentsDownloadImageResponse.error)
      return
    } else {
      // console.log(postDocumentsDownloadImageResponse.data)
      setImageList(postDocumentsDownloadImageResponse.data)
      hasVerticalView(postDocumentsDownloadImageResponse.data)
      // console.log(hasVerticalView(postDocumentsDownloadImageResponse.data))
    }
  }
  const [selectedDocument, setSelectedDocument] = useState()

  const handleSelectDocument = (documentItem) => {
    if (selectedDocument === documentItem.id) {
      setSelectedDocument()
      setSelectedImage([])
    } else {
      setSelectedDocument(documentItem.id)
      setSelectedImage([])
    }
  }
  useEffect(() => {
    if (selectedDocument) {
      postDocumentsDownloadImageApi(selectedDocument)
    }
    // eslint-disable-next-line
  }, [selectedDocument])

  const [selectedImage, setSelectedImage] = useState([])
  const handleSelectImage = (id) => {
    if (!selectedImage?.includes(id)) {
      setSelectedImage((prev) => [...prev, id])
    } else {
      const unSelectedImage = selectedImage.filter((item) => item !== id)
      setSelectedImage(unSelectedImage)
      // getSelectedSlide(unSelectedSlide)
    }
  }

  const handleAllCheck = (list) => {
    if (selectedImage.length !== imageList.length) {
      const checked = []
      list.forEach((item) => checked.push(item.fileImageId))
      setSelectedImage(checked)
    } else {
      setSelectedImage([])
    }
  }

  const [isVerticalView, setIsVerticalView] = useState(false)

  const hasVerticalView = (list) => {
    if (list.some((item) => item.width < item.height)) {
      setIsVerticalView(true)
    } else {
      setIsVerticalView(false)
    }
  }

  return (
    <div className='fixed left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto bg-dimmer-default'>
      <div className='modal_xs board:modal_md board:gap-20 tab:h-[400px] board:h-[526px] board:min-w-[1028px] board:max-w-[1272px] board:pb-20 tab:min-w-[770px] tab:modal_sm tab:pb-16 tab:gap-16 h-[342px] max-w-[592px] gap-12'>
        <div className='board:gap-20 tab:gap-16 flex h-full flex-col gap-12'>
          <div className='tab:text-h1-semibold text-caption-semibold text-label-default'>
            자료 불러오기
          </div>
          {!search && documentList.length === 0 ? (
            <div className='board:gap-16 board:rounded-12 flex h-full w-full flex-col items-center justify-center gap-8 rounded-6 bg-fill-normal'>
              <DataNull />
              <div className='board:gap-4 text-caption3-medium board:text-h2-medium flex flex-col gap-2 text-center text-label-placeholder'>
                <p>과목 자료실에 등록된 자료가 없습니다.</p>
                <p>선생님 웹에 접속하여 자료를 먼저 업로드 해주세요!</p>
              </div>
            </div>
          ) : (
            <div className='tab:gap-12 flex h-full w-full gap-8 overflow-hidden'>
              <div className='tab:gap-12 flex h-full grow flex-col items-start gap-8'>
                <div className='tab:min-h-[32px] flex min-h-24 w-full justify-between'>
                  <div className='tab:gap-16 flex items-center gap-8'>
                    {sortedByList.map((item) => (
                      <div
                        key={item.id}
                        onClick={() => setSortedBy(item.id)}
                        className={`tab:gap-4 flex cursor-pointer items-center justify-center gap-2 ${
                          sortedBy === item.id
                            ? 'fill-label-sub text-label-sub'
                            : 'fill-label-placeholder text-label-placeholder'
                        }`}
                      >
                        <Dot className='h-10 w-10' />
                        <p className='text-caption2-medium tab:text-body3-medium'>{item.name}</p>
                      </div>
                    ))}
                  </div>
                  <div className='tab:gap-8 flex h-full items-center gap-4'>
                    <div className='relative h-full'>
                      <Search className='tab:left-16 tab:top-8 absolute left-6 top-4' />
                      <input
                        type='text'
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder='자료 검색'
                        className='tab:input_sm tab:pl-40 input_xs tab:min-w-[210px] h-full'
                      />
                      {search && (
                        <CloseFilled
                          onClick={() => setSearch('')}
                          className='tab:right-8 tab:top-8 absolute right-6 top-4 cursor-pointer'
                        />
                      )}
                    </div>
                  </div>
                </div>
                {/* dataList */}
                <div className='h-full w-full'>
                  <div className='tab:px-16 tab:py-6 board:py-8 text-caption2-regular tab:gap-16 tab:text-body3-regular board:gap-16 flex w-full items-center gap-16 border-y-[1px] border-solid border-border-default bg-fill-alternative px-12 py-4 text-label-info'>
                    <p className='tab:min-w-[318px] board:min-w-[448px] min-w-[226px]'>이름</p>
                    <p className='tab:min-w-[88px] min-w-60'>등록 일자</p>
                  </div>
                  <div
                    className={`${search && documentList.length === 0 ? 'board:h-[calc(100%-32px)] h-full' : 'board:h-[calc(100%-74px)] h-[calc(100%-48px)]'} scroll-bar-xs w-full overflow-y-scroll pr-4`}
                  >
                    {search && documentList.length === 0 ? (
                      <div className='flex h-full w-full items-center justify-center'>
                        <p className='text-caption3-medium board:text-body2-long-medium text-center text-label-placeholder'>
                          검색 결과가 없습니다.
                          <br />
                          검색하고자 하는 글자를 완전히 입력하거나 다른 검색어를 입력해보세요.
                        </p>
                      </div>
                    ) : (
                      documentList?.map((documentItem, documentIndex) => (
                        <div
                          // ref={menuRef}
                          key={documentIndex}
                          onClick={async () => {
                            handleSelectDocument(documentItem)
                          }}
                          className='relative'
                        >
                          <div
                            className={`${selectedDocument === documentItem.id ? 'bg-background-secondary' : 'bg-background-default'} tab:px-16 board:p-16 flex items-center justify-between border-b-[1px] border-solid border-border-default px-12 py-10 active:bg-background-secondary`}
                          >
                            <div className='flex items-center gap-16'>
                              <div className='tab:w-[318px] board:min-w-[448px] flex w-[226px] items-center gap-8'>
                                <div className='tab:min-h-24 tab:min-w-24 h-20 min-w-20'>
                                  {fileTypeList[documentItem.fileType]}
                                </div>
                                <div className='text-caption2-regular tab:text-body2-regular board:text-body1-regular overflow-hidden text-ellipsis whitespace-nowrap text-start text-label-sub'>
                                  {`${documentItem.fileName}.${documentItem.fileType.toLowerCase()}`}
                                </div>
                              </div>
                              <p className='text-caption2-medium tab:text-body2-medium tab:min-w-[88px] min-w-60 text-label-sub'>
                                {documentItem.createdAt}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
              <div className='tab:w-[236px] tab:rounded-10 board:w-[340px] board:rounded-12 flex min-w-[210px] items-center justify-center rounded-6 bg-fill-normal'>
                {selectedDocument ? (
                  <div className='tab:px-8 flex h-full w-full flex-col items-start justify-start px-[5px]'>
                    <div className='flex w-full items-center justify-between py-[7px]'>
                      <div
                        onClick={() => handleAllCheck(imageList)}
                        className='tab:py-10 board:py-[13px] flex cursor-pointer items-center gap-4'
                      >
                        {selectedImage.length > 0 && selectedImage.length === imageList.length ? (
                          <CheckedBox className='tab:w-20 tab:h-20 h-[14px] w-[14px]' />
                        ) : (
                          <CheckBox className='tab:w-20 tab:h-20 h-[14px] w-[14px]' />
                        )}
                        <p
                          className={`text-caption3-medium tab:text-body3-medium board:text-body2-medium ${selectedImage.length > 0 && selectedImage.length === imageList.length ? 'text-border-active' : 'text-label-info'}`}
                        >
                          {selectedImage.length > 0 && selectedImage.length === imageList.length
                            ? '전체 선택 해제'
                            : '전체 선택'}
                        </p>
                      </div>
                      <div className='tab:border flex h-min items-center overflow-hidden rounded-4 border-[0.5px] border-solid border-border-default'>
                        <div
                          onClick={() => setIsVerticalView(true)}
                          className={`tab:px-[13px] tab:py-[5px] px-12 py-[3px] ${isVerticalView ? 'bg-primary-normal' : 'bg-background-secondary'}`}
                        >
                          <div
                            className={`tab:h-[14px] tab:w-10 h-12 w-8 rounded-[1px] border ${isVerticalView ? 'border-static-white' : 'border-primary-normal'}`}
                          />
                        </div>
                        <div
                          onClick={() => setIsVerticalView(false)}
                          className={`tab:py-[7px] tab:px-[11px] px-10 py-[5px] ${isVerticalView ? 'bg-background-secondary' : 'bg-primary-normal'}`}
                        >
                          <div
                            className={`tab:h-10 tab:w-[14px] h-8 w-12 rounded-[1px] border ${isVerticalView ? 'border-primary-normal' : 'border-static-white'}`}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${isVerticalView ? 'tab:grid-cols-2 board:grid-cols-3 grid-cols-3' : 'tab:grid-cols-1 board:grid-cols-2 grid-cols-2'} board:gap-8 scroll-bar-xs grid w-full gap-4 overflow-y-scroll pb-[7px]`}
                    >
                      {imageList.length > 0 &&
                        imageList?.map((imageItem, index) => (
                          <div
                            key={index}
                            onClick={() => handleSelectImage(imageItem.fileImageId)}
                            className={`${isVerticalView ? 'tab:h-[140px] h-[86px] w-full' : 'tab:h-[115px] board:h-[85px] h-[53px] w-full'}`}
                          >
                            <Slide
                              url={imageItem.fileSignUrl}
                              id={imageItem.fileImageId}
                              selectedSlide={selectedImage}
                              pageNum={index + 1}
                              selectedMode={Boolean(selectedDocument)}
                              isSmall={true}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                ) : (
                  <div className='flex flex-col items-center gap-8'>
                    <SelectNull className='h-40 w-40' />
                    <p className='text-caption2-medium tab:text-body3-medium board:text-body2-long-medium text-center text-label-placeholder'>
                      리스트에서 불러올
                      <br />
                      자료를 선택하세요
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
          <div className='flex w-full justify-end'>
            <div
              className={`${documentList?.length > 0 ? 'tab:w-[256px] board:w-[320px] w-[192px]' : 'tab:min-w-[124px] board:min-w-[152px] min-w-100'} board:gap-16 flex justify-end gap-8`}
            >
              <button
                onClick={close}
                className='button_outlined_secondary text-caption2-medium tab:button_outlined_secondary_lg tab:py-10 tab:text-label-sub tab:text-body2-semibold tab:min-w-[124px] w-full rounded-6 py-8 text-label-sub'
              >
                취소
              </button>
              {documentList?.length > 0 && (
                <button
                  disabled={selectedImage.length === 0}
                  onClick={async () => {
                    await postClassRoomBoardDocumentApi(selectedImage)
                    await getApi()
                    close()
                  }}
                  className={`text-caption2-medium tab:py-10 tab:text-body2-semibold tab:px-20 tab:min-w-[124px] w-full text-nowrap rounded-6 py-8 ${selectedImage.length > 0 ? 'button_solid_primary tab:button_solid_primary_lg' : 'button_solid_primary_disabled tab:button_solid_primary_disabled_lg'}`}
                >
                  {`${selectedImage.length > 0 ? `선택 자료 추가(${selectedImage.length})` : '선택 자료 추가'}`}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
